<app-versatile-list>
    <app-versatile-list-header [isLoading]="isLoading">
        <div class="header-content" *ngIf="!isLoading">
            <div class="title">
                <span class="name">{{ 'admin.strain.sample-boards.details.tabs.stoc.title' | translate }}</span>
                <span class="count">({{ filteredItems.length }} items)</span>
                <app-icon
                    class="edit-stock"
                    library="material"
                    variant="edit"
                    type="info"
                    [ngClass]="{'disabled': isLoading || isSaving}"
                    (click)="onEditStockClick()">
                </app-icon>
            </div>
            <app-tabs
                [tabs]="tabs"
                [material]="false"
                [autorouting]="false"
                (tabClicked)="onTabsChange($event)">
            </app-tabs>
        </div>
    </app-versatile-list-header>

    <app-versatile-list-body
        [items]="filteredItems"
        [total]="filteredItems?.length || 0"
        [isLoading]="isLoading">
        <ng-template versatileListItem let-item>
            <app-sample-board-stoc-list-item
                class="list__item"
                [item]="item">
            </app-sample-board-stoc-list-item>
        </ng-template>

        <ng-container versatileListEmpty>
            <app-empty-state
                icon="fa-archive"
                text="No stock items">
            </app-empty-state>
        </ng-container>
    </app-versatile-list-body>
</app-versatile-list>
